module.exports = __webpack_public_path__ + "images/lancia99c83d5ecc389c5f8a112849afd17a9f.png";